export const TYPE_THEME = 'UPDATE_THEME';
export const updateTheme = (mode) => ({
  type: TYPE_THEME,
  payload: mode,
});

export const setTheme = (mode) => async (dispatch) => {
  dispatch(updateTheme(mode));
};
